import styled from "styled-components";

/** Section 3. See Hero.styles.ts for the px-not-rem note. */
export const Wrapper = styled.section`
  position: relative;
  background: var(--brand-bone);

  .inner {
    margin: 0 auto;
    max-width: 1152px;
    padding: 80px 20px;
  }

  .head {
    margin-bottom: 40px;
    text-align: center;
  }

  .eyebrow {
    margin: 0 0 12px;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.2em;
    color: var(--brand-red);
  }

  .heading {
    margin: 0 auto;
    max-width: 672px;
    font-family: var(--brand-display);
    font-size: 36px;
    font-weight: 800;
    letter-spacing: -0.025em;
    line-height: 1.1;
    color: var(--brand-ink);
  }

  /* the translucent red swipe, same treatment as the hero headline */
  .marked {
    position: relative;
    display: inline-block;

    &:before {
      content: "";
      position: absolute;
      left: -6px;
      right: -6px;
      top: 16%;
      bottom: 12%;
      border-radius: 2px;
      background: rgba(209, 31, 61, 0.15);
      z-index: 0;
    }

    span {
      position: relative;
      z-index: 1;
    }
  }

  .cards {
    display: grid;
    gap: 24px;
  }

  @media screen and (min-width: 640px) {
    .inner {
      padding: 80px 32px;
    }

    .heading {
      font-size: 48px;
    }

    .cards {
      grid-template-columns: repeat(3, 1fr);
    }
  }
`;

export const Card = styled.article`
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 28px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  background: #fff;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);

  .media {
    position: relative;
    overflow: hidden;
    aspect-ratio: 4 / 3;
  }

  /* aspect-ratio fallback for the browsers CRA 4 still targets */
  @supports not (aspect-ratio: 4 / 3) {
    .media {
      height: 0;
      padding-bottom: 75%;

      img {
        position: absolute;
        inset: 0;
      }
    }
  }

  .media img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    transition: transform 0.5s;
  }

  &:hover .media img {
    transform: scale(1.03);
  }

  .pill {
    position: absolute;
    left: 12px;
    top: 12px;
    border-radius: 999px;
    background: #fff;
    padding: 4px 12px;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    color: var(--brand-red);
    box-shadow:
      0 1px 3px 0 rgba(0, 0, 0, 0.1),
      0 0 0 1px rgba(0, 0, 0, 0.05);
  }

  .body {
    display: flex;
    flex: 1;
    flex-direction: column;
    padding: 20px 24px 24px;
  }

  .title {
    margin: 0;
    font-family: var(--brand-display);
    font-size: 20px;
    font-weight: 800;
    line-height: 1.375;
    color: var(--brand-ink);
  }

  .text {
    margin: 8px 0 0;
    font-size: 14px;
    line-height: 1.625;
    color: rgba(14, 17, 22, 0.65);
  }

  .link {
    appearance: none;
    background: none;
    border: none;
    /* vertical padding lifts the tap target to ~44px on touch screens; the
     * reduced margin keeps the visual gap the same as the reference. */
    padding: 14px 0;
    margin-top: 6px;
    cursor: pointer;
    align-self: flex-start;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-family: var(--brand-sans);
    font-size: 14px;
    font-weight: 700;
    color: var(--brand-red);
    transition: color 0.2s;

    svg {
      width: 16px;
      height: 16px;
    }

    &:hover {
      color: var(--brand-red-deep);
    }

    &:focus-visible {
      outline: 2px solid var(--brand-red);
      outline-offset: 3px;
    }
  }
`;
